import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { TEMPLATE_MASTER_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const TemplateMasterApi = createApi({
  reducerPath: "templateMaster",
  baseQuery,
  tagTypes: ["TemplateMaster"],
  endpoints: (builder) => ({
    getTemplateMaster: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: TEMPLATE_MASTER_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: TEMPLATE_MASTER_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["TemplateMaster"],
    }),
    getTemplateMasterById: builder.query({
      query: (id) => {
        return {
          url: `${TEMPLATE_MASTER_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["TemplateMaster"],
    }),
    addTemplateMaster: builder.mutation({
      query: (payload) => ({
        url: TEMPLATE_MASTER_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["TemplateMaster"],
    }),
    updateTemplateMaster: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${TEMPLATE_MASTER_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["TemplateMaster"],
    }),
    deleteTemplateMaster: builder.mutation({
      query: (id) => ({
        url: `${TEMPLATE_MASTER_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["TemplateMaster"],
    }),
  }),
});

export const {
  useAddTemplateMasterMutation,
  useGetTemplateMasterQuery,
  useDeleteTemplateMasterMutation,
  useGetTemplateMasterByIdQuery,
  useUpdateTemplateMasterMutation

} = TemplateMasterApi;

export default TemplateMasterApi;
